"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.1.2'] && _();
}
catch (e) { }
